import { render, staticRenderFns } from "./CompanySupportHub.vue?vue&type=template&id=26dd9157"
import script from "./CompanySupportHub.vue?vue&type=script&lang=js"
export * from "./CompanySupportHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports